import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router';

function slugify(name) {
    return name.toLowerCase().replace(/\s+/g, '-');
}

function getTabName(tab) {
    return typeof tab === 'string' ? tab : tab.tabName;
}

export default function useHashTab(tabNames, ref) {
    const location = useLocation();
    const history = useHistory();

    const slugs = useMemo(
        () => tabNames.map((t) => slugify(getTabName(t))),
        [tabNames],
    );

    const hash = location.hash ? location.hash.slice(1) : '';
    const matchIndex = slugs.indexOf(hash);
    const selectedIndex = matchIndex >= 0 ? matchIndex : undefined;

    // Scroll to the tab section once when the hash first changes
    const lastScrolledHash = useRef('');
    useEffect(() => {
        if (
            selectedIndex !== undefined &&
            ref?.current &&
            hash !== lastScrolledHash.current
        ) {
            lastScrolledHash.current = hash;
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [hash, selectedIndex, ref]);

    const onChange = useCallback(
        (index) => {
            history.replace({ ...location, hash: slugs[index] });
        },
        [history, location, slugs],
    );

    return { selectedIndex, onChange };
}
